export default __webpack_public_path__ + "static/media/lines-no-1.dbd05d27.mid";